import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import axios from 'axios';
import './leaderboard.css'; // Import the CSS file
import { MoonLoader, PropagateLoader, SyncLoader } from 'react-spinners';
import confetti from 'canvas-confetti';
import { Fade } from 'react-awesome-reveal';

function Leaderboard() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState(''); // State for the search term
  const leaderboardRef = useRef(null); // Reference for leaderboard container
  const handleCelebrate = () => {
    for (let i = 0; i < 5; i++) {
      confetti({
        particleCount: 150,
        angle: Math.random() * 360,
        spread: 40,
        startVelocity: 40,
        origin: {
          x: Math.random(), // Random horizontal position
          y: Math.random(), // Random vertical position
        },
      });
    }
  };

  const runConfetti = () => {
    const duration = 6 * 1000; 
    const animationEnd = Date.now() + duration;
    const defaults = { startVelocity: 40, spread: 50, ticks: 100, zIndex: 9999 };
  
    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();
  
      if (timeLeft <= 0) {
        clearInterval(interval);
        return;
      }
  
      const particleCount = 300 * (timeLeft / duration); // Gradual fade-out
      confetti(
        Object.assign({}, defaults, {
          particleCount,
          origin: {
            x: Math.random(),
            y: Math.random() - 0.2, // Slightly above the screen center
          },
        })
      );
    }, 200); // Fire bursts every 250ms
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          'https://script.googleusercontent.com/macros/echo?user_content_key=bD48ahWnkd_rby3E2XSyIq4yZA40F9I9RH7xtyuKjr3zjPmmcksEYnMc9nqxkojNbgoi1SUMjTOu94APMcnOC4_5XDyF_PVwm5_BxDlH2jW0nuo2oDemN9CCS2h10ox_1xSncGQajx_ryfhECjZEnH2xuIF1W4qD4Xa43EdYXFAJl7gGig-n33P0_tzBoETz_bo6U0_MNXyEzsaIj-ar7qZH1Hi6N4AlBsVE3UjejJ9ngpV7QgBgQtz9Jw9Md8uu&lib=MkSZKs9tcAlkRId8apxVWWTWJDASvw3_b'
        );
        setData(response.data);
        setLoading(false);
        runConfetti(); // Trigger confetti here after loading is complete
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };
  
    fetchData();
  }, []);

  useLayoutEffect(() => {
    // Scroll to leaderboard container immediately after data is loaded
    if (leaderboardRef.current && !loading) {
      leaderboardRef.current.scrollIntoView({ behavior: 'smooth', block:'start', });
    }
  }, [data, loading]); // Trigger scroll when data is updated or loading is false

  const filteredData = data.filter(row =>
    row['User Name'].toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
    <div className="live">
         <p className="center-text">Final Result - GenAI Study Jams & Arcade 2024-25</p>
         <p className="end-button">
            <button onClick={handleCelebrate}>Celebrate Achievement</button>
         </p>
      </div>


      <div className="analytics">
        <div className="data_card">
          <div>No of participants enrolled</div>
          <p>195</p>
        </div>

        <div className="data_card">
          <div>No of participants completed 15 Skill Badges & 1 Arcade Game</div>
          <p>97</p>
        </div>

        <div className="data_card">
          <div>No of participants completed Arcade</div>
          <p>152</p>
        </div>
      </div>

      <div className="search-container">
        <input
          type="text"
          className="search-box"
          placeholder="Search Your Name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="leaderboard-container" ref={leaderboardRef}>
        {loading ? (
          <p className="Loadingdata">
            <MoonLoader size={40} speedMultiplier={0.7} color="#ff6600" />
            <p>Leaderboard is loading...</p>
          </p>
        ) : (
          <>
            {filteredData.length === 0 ? (
              <p className="not-found">No result found</p> // Message when no data is found
            ) : (
              <table className="leaderboard-table">
                <thead>
                  <tr>
                    <th> <Fade>Rank. </Fade> </th>
                    <th> <Fade>Name </Fade> </th>
                    <th className="email-column"> <Fade >User Email </Fade> </th>
                    <th> <Fade>Access Code Redemption </Fade> </th>
                    <th> <Fade>All Skill Badges & Games Completed </Fade> </th>
                    <th> <Fade>No of Skill Badges Completed </Fade> </th>
                    <th> <Fade>No of Arcade Games Completed </Fade> </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((row, index) => (
                    <tr key={index}>
                      <td>{row['Sr No.']}</td>
                      <td>{row['User Name']}</td>
                      <td className="email-column">{row['User Email']}</td>
                      <td className="centered-cell">
                        <p className={`${row['Access Code Redemption Status'] === 'Yes' ? 'yes-cell' : 'no-cell' }`}>
                          {row['Access Code Redemption Status']}
                        </p>
                      </td>
                      <td className="centered-cell">
                        <p className={`${row['All Skill Badges & Games Completed'] === 'Yes' ? 'yes-cell' : 'no-cell' }`}>
                          {row['All Skill Badges & Games Completed']}
                        </p>
                      </td>
                      <td className="centered-cell">{row['# of Skill Badges Completed']}</td>
                      <td className="centered-cell">
                        <p className={`${row['# of Arcade Games Completed'] == '1' ? 'yes-cell' : 'no-cell' }`}>
                          {row['# of Arcade Games Completed']}
                        </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default Leaderboard;
